import { type FC } from "react";

import { type TGridSelModelIdentifier } from "../../../../../app-utils/selection-model.js";
import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import { TableCell } from "./TableCell.js";

export interface ICheckboxCellProps extends IAgGridCellProps {
  onChange: (rowIndex: number, rowId: TGridSelModelIdentifier, selected: boolean, rangeCheck: boolean) => void;
}

const CheckboxCell: FC<ICheckboxCellProps> = (props) => {
  const handleChange = (event: any, rowIndex: number, rowId: TGridSelModelIdentifier, checked: boolean) => {
    const rangeCheck: boolean = event.nativeEvent.shiftKey; // get from original dom event
    props.onChange(rowIndex, rowId, checked, rangeCheck);
  };

  if (props.data) {
    const { rowIndex, data } = props;

    const rowId: TGridSelModelIdentifier = data.id || props.node.id;
    const checked: boolean = props.node.selected;
    const checkboxId = `checkbox_${data.groupType}_${rowIndex}`;

    return (
      <TableCell>
        <div className="checkbox" style={{ paddingTop: 5, paddingLeft: 3.5 }}>
          {data.isSelectable !== false && (
            <>
              <input
                type="checkbox"
                key={checkboxId}
                id={checkboxId}
                checked={checked}
                onChange={() => null}
                data-checked={checked}
              />
              <label htmlFor={checkboxId} onClick={(event) => handleChange(event, rowIndex, rowId, !checked)} />
            </>
          )}
        </div>
      </TableCell>
    );
  }

  return null;
};

export default CheckboxCell;
